import { render } from "./BlocksPage.vue?vue&type=template&id=57db4320"
import script from "./BlocksPage.vue?vue&type=script&lang=js"
export * from "./BlocksPage.vue?vue&type=script&lang=js"

import "./BlocksPage.vue?vue&type=style&index=0&id=57db4320&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__